import gql from "graphql-tag";

export const BASIC_STATISTICS = gql`
  query statistics(
    $excludedImgType: String!
    $completedTaskStatus: String!
  ) {
    Statistics(
      excludedImgType: $excludedImgType
      completedTaskStatus: $completedTaskStatus
    ) {
      numberOfContributions,
      numberOfPersons,
      numberOfProjects,
      numberOfRecordings,
      numberOfVideos,
      numberOfImages,
      numberOfSourceFiles,
      numberOfTasks,
      numberOfCompletedTasks,
      numberOfCommentsOnTasks,
      numberOfReferences,
      numberOfReferencesComments,
      numberOfWorks,
      numberOfWorksComments,
      numberOfLives,
      numberOfAcceptedInvitations,
      numberOfPendingInvitations,
      numberOfTexts
    }
  }
`;
